<template>
  <b-row>
    <b-col sm="12">
        <div v-if="pieOptions == null" class="text-center" style="font-size: 1em; padding: 100px 0px 100px;">
          <b-badge>There's no statistics data</b-badge>
        </div>
        <vue-highcharts v-else :options="pieOptions"></vue-highcharts>
    </b-col>
  </b-row>
</template>

<script>
import VueHighcharts from 'vue2-highcharts'
import * as initConfigChart from '@/views/components/charts/HighchartInit'
import axios from 'axios'

export default {
  name: 'visitorPieChart',
  components: {
    VueHighcharts
  },
  data () {
    return {
      apiPieStatsComplaint: window.AppConfig.apiUrl + 'complaint-stats.category',
      apiUrlComplaintCategory: window.AppConfig.apiUrl + 'complain-category',
      complaintCategoryList: [],
      pieOptions: null,
      colors: ['#ffc107', '#20a8d8', '#4dbd74', '#DBCE51', '#16B582', '#21C273', '#44B167', '#E9BE46', '#497D65', '#4D421E', '#48D422', '#81C1A5', '#FA3150', '#34946E', '#F28E35', '#5E2E51', '#3D50A6', '#A4C6CC', '#7B5235', '#C455AE', '#D10DAD', '#7E9A78', '#583A49', '#F5DB2E', '#FCE797', '#3C2BCC', '#D28563', '#ABB53B', '#2A72E7', '#B59438', '#A52276', '#157055', '#056F34', '#341766', '#52AEEB', '#C9CEA3', '#B6AB24', '#89969C', '#D98151', '#9B3C1B', '#77387B', '#5E936A', '#38653B', '#3D5982', '#003F53', '#851559', '#EE8163', '#12A785', '#B5F358', '#19664D', '#FEF5BB', '#6DE597', '#17CF34', '#D182C6', '#BB2CD7', '#515762', '#BF4293', '#AE7242', '#B4E7E7', '#2B4AAA', '#2FC13F', '#37BBCD', '#3B3BCB', '#6EF7BA', '#626605', '#E9ABAC', '#8D36D5', '#DB2202', '#E423D5', '#61BC5C', '#57613E', '#923D28', '#39C383', '#B5601D', '#1A3C61', '#347507', '#12DD27', '#E5443A', '#B43C4C', '#66FD29', '#1E1538', '#4697E8', '#0BF51A', '#C262FF', '#A62237', '#98D1BF', '#1ADAAC', '#42FBC1', '#585AA0', '#563515', '#E8BADC', '#A3B65E', '#B39E4D', '#25E544', '#6EEC8B', '#D99982', '#139FBA', '#0F6744', '#718A1C', '#4EE119', '#C9C813', '#FBF3B5', '#9E6A71']
    }
  },
  mounted () {
    try {
      this.getComplaintStats()
      this.doAutoRefresh()
    } catch (err) { window.consoleLog(err) }
  },
  beforeDestroy () {
    clearInterval(this.refComplaintPie)
  },
  methods: {
    getComplaintStats () {
      axios.get(this.apiUrlComplaintCategory).then(response => {
        if (response !== undefined) {
          let datas = response.data._embedded.complainCategory
          for (let i = 0; i < response.data.total_items; i++) {
            this.complaintCategoryList[datas[i].name] = datas[i].uuid
          }
          axios.get(this.apiPieStatsComplaint)
            .then(response => {
              if (response === undefined) return false
              if (Object.keys(response.data).length) {
                // check all data is return 0
                // return null if yes
                let tmp = 0
                for (let key in response.data) tmp += parseInt(response.data[key])
                if (tmp !== 0) {
                  let dataChart = []
                  Object.keys(response.data).forEach(function (key) {
                    dataChart.push({
                      'name': key,
                      'y': parseInt(response.data[key]),
                      'sliced': dataChart.length === 0,
                      'selected': dataChart.length === 0
                    })
                  })
                  let opt = initConfigChart.pieOptions
                  opt.series = [{
                    name: 'data',
                    data: dataChart
                  }]
                  // opt.colors = []
                  let self = this
                  opt.plotOptions.pie.point = {
                    events: {
                      click: function (e) {
                        self.redirectToPage(this.name)
                        return false
                      }
                    }
                  }
                  for (let i = 0; i < Object.keys(response.data).length; i++) {
                    opt.colors.push(this.colors[i])
                  }
                  this.pieOptions = opt
                } else {
                  this.pieOptions = null
                }
              }
            })
            .catch(error => {
              this.$store.dispatch('errorMessage', error)
                .then(errMsg => {
                  this.$alertify.error(errMsg)
                })
            })
        }
      })
    },

    redirectToPage (categoryName) {
      this.$router.push({ path: '/complaint', query: { 'complain_category_uuid': this.complaintCategoryList[categoryName] } })
    },

    doAutoRefresh () {
      this.refComplaintPie = setInterval(() => {
        this.getComplaintStats()
      }, window.AppConfig.IntervalRefreshData)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/index/complaintPieChartByCategory.vue